import React from "react";

const Java_Default = () => {
  return (
    <div>
      <h1>Java Default</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Default in Java.</p>
    </div>
  );
};

export default Java_Default;
